module.exports = __webpack_public_path__ + "img/61.1d22e562.jpg";